import { RDGovernmentFunded } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDGovernmentFundedEditor } from './GovernmentFundedEditor'

export const GovernmentFundedTaskDefinition: ResourceDetailFeature<RDGovernmentFunded> = {
  traitId: 'governmentFunded',
  TaskEditor: RDGovernmentFundedEditor,
}
